import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDatepickerInputEvent,
} from "@angular/material";
import { DlaService } from "src/app/shared/dla.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Payment } from "src/app/model/payment.model";
import { NgxSpinnerService } from "ngx-spinner";
import { AlertService } from "ngx-alerts";import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-coupon-payment',
  templateUrl: './coupon-payment.component.html',
  styleUrls: ['./coupon-payment.component.css']
})
export class CouponPaymentComponent implements OnInit {
  cPaymentForm: FormGroup;
  submitted = false;
  session_type: string;
  selected_session_type: string = "";
  sessionOptions: any[] = [
    { id: "physical", name: "IN PERSON" },
    { id: "online", name: "VIRTUAL" },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CouponPaymentComponent>,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private dlaService: DlaService
  ) { 
    this.cPaymentForm = this.formBuilder.group({
      couponCode: ["", Validators.required],
      accountType: [this.selected_session_type, Validators.required],
    });

  }

  ngOnInit(): void {
     console.log('Session: ', this.data.userinfo);
    this.session_type = this.data.session_type;
    this.selected_session_type =
      this.session_type == "online" ? "online" : "physical";
    if (this.session_type == "online" || this.session_type == "physical") {
      this.cPaymentForm.controls["accountType"].setValue(
        this.selected_session_type
      );
    }

    console.log(`The session type inside offline payment ${this.session_type}`);
  }

  get f() {
    return this.cPaymentForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.cPaymentForm.invalid) {
      return;
    }

    this.selected_session_type = this.cPaymentForm.value.accountType;

    let paymentRequest: Payment = {
      user_id: this.data.userinfo.user_id,
      session_id: this.data.session.session_id,
      course_id: this.data.session.course_id,
      type: "coupon",
      amount: this.data.session.main_fee,
      description:
        "Payment for " +
        this.data.session.course +
        "(" +
        this.data.session.theme +
        ")",
      paid_by: this.data.userinfo.firstname + ' ' + this.data.userinfo.lastname,
      hash: "",
      mode_of_attendance: this.selected_session_type,
      reference_number: this.cPaymentForm.value.couponCode,
      has_prerequisite: this.data.session.has_prerequisite,
    };

     console.log(paymentRequest);

    this.dlaService.makeCouponPayment(paymentRequest).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          localStorage.clear();
          localStorage.setItem("dla_student", JSON.stringify(data.user));
          this.alertService.success(data.message);
          this.spinner.hide();
          this.cPaymentForm.reset();
          this.dialogRef.close();
        } else {
          this.spinner.hide();
          this.alertService.danger(data.message);
        }
      },
      (error) => {
        this.spinner.hide();
        // console.log('Error: ', error);
        this.alertService.danger("An error occurred, Please try again");
      }
    );
  }


  padString(n) {
    const z = "0";
    return n.length >= 2 ? n : new Array(2 - n.length + 1).join(z) + n;
  }

  checkSeletedType(event: string) {
    this.selected_session_type = event;
  }

}
